import { dataGridSortDirection } from '@shared/components';
import { parseAsPageNumber } from '@shared/utils';
import { parseAsInteger, parseAsString, parseAsStringLiteral, useQueryStates } from 'nuqs';

type SortOrder = (typeof dataGridSortDirection)[number];

export function useExamEventExamineeResultListSearchParams() {
  const [{ page, pageSize, sortOrder, sortBy }, setQueryParams] = useQueryStates({
    page: parseAsPageNumber.withDefault(0),
    pageSize: parseAsInteger.withDefault(50),
    sortOrder: parseAsStringLiteral(dataGridSortDirection).withDefault('asc'),
    sortBy: parseAsString.withDefault('seatNumber'),
  });

  const changePageNumber = (page: number) => {
    setQueryParams({ page });
  };

  const changePageSize = (pageSize: number) => {
    setQueryParams({ pageSize, page: 0 });
  };

  const changeSorting = ({
    sortOrder,
    sortBy,
  }: {
    sortOrder: SortOrder | null;
    sortBy: string | null;
  }) => {
    setQueryParams({ sortOrder, page: 0, sortBy });
  };

  return [
    {
      page,
      pageSize,
      sortOrder,
      sortBy,
    },
    { changePageNumber, changePageSize, changeSorting },
  ] as const;
}
